import { PROPERTY_BUSINESS_TYPES } from '../lib/propertyBusinessTypes';

// Shared presentation; callbacks retain each page's existing type metadata and flow.
export const PropertyTypePicker = ({ types = PROPERTY_BUSINESS_TYPES, onSelect, testIdPrefix, showDetails = false }) => {
  const available = new Map(types.map(type => [type.key, type]));
  const commercial = PROPERTY_BUSINESS_TYPES.filter(type => type.key !== 'residential' && available.has(type.key));
  const residential = PROPERTY_BUSINESS_TYPES[0];

  const renderType = type => {
    const details = available.get(type.key);
    return (
    <button
      key={type.key}
      type="button"
      onClick={() => onSelect(available.get(type.key))}
      className="property-intake-type w-full min-w-0 p-4 rounded-2xl border-2 text-left transition-[transform,border-color] hover:scale-[1.02] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-300"
      style={{
        backgroundColor: 'rgba(2, 6, 23, 0.78)',
        borderColor: type.strategic ? 'rgba(245, 158, 11, 0.4)' : 'rgba(94, 234, 212, 0.25)',
      }}
      data-testid={`${testIdPrefix}-type-${type.key}`}
    >
      <span className="text-3xl" aria-hidden="true">{type.icon}</span>
      {showDetails && <p className="text-sm font-bold text-white leading-snug mt-2 break-words" data-testid={`${testIdPrefix}-type-label-${type.key}`}>{details.label}</p>}
      <p className={`font-bold break-words ${showDetails ? 'text-[11px] mt-1' : 'text-xs uppercase tracking-widest mt-2'}`} style={{ color: showDetails ? '#C9A962' : type.strategic ? '#fbbf24' : '#5eead4' }} data-testid={`${testIdPrefix}-type-necs-name-${type.key}`}>
        {showDetails ? details.necs_name : type.necs}
      </p>
      {showDetails ? <>
        <p className="text-[10px] text-zinc-300 mt-0.5 leading-snug break-words" data-testid={`${testIdPrefix}-type-description-${type.key}`}>{details.tagline}</p>
        <p className="text-[10px] text-zinc-400 mt-2" data-testid={`${testIdPrefix}-type-package-summary-${type.key}`}>
          {details.services?.length ?? '—'} services · {details.custom_only ? 'custom' : `${details.tiers?.length ?? '—'} tiers`}
        </p>
      </> : <p className="text-sm text-white leading-snug mt-1 break-words" data-testid={`${testIdPrefix}-type-label-${type.key}`}>{type.label}</p>}
      {type.strategic && <p className="text-[9px] uppercase tracking-widest mt-2 font-black text-amber-400" data-testid={`${testIdPrefix}-type-strategic-${type.key}`}>Strategic Enterprise</p>}
    </button>
    );
  };

  return <>
    <p className="text-center text-xs uppercase tracking-widest text-zinc-200 mb-4" data-testid={`${testIdPrefix}-type-prompt`}>Choose your business type</p>
    {available.has('residential') && <div className="max-w-md mx-auto mb-4" data-testid={`${testIdPrefix}-type-residential-row`}>{renderType(residential)}</div>}
    <p className="text-center text-[10px] uppercase tracking-[0.28em] font-black mt-6 mb-3 text-[#C9A962]" data-testid={`${testIdPrefix}-commercial-type-heading`}>12 Commercial Business Types</p>
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3" data-testid={`${testIdPrefix}-type-grid`}>
      {commercial.map(renderType)}
    </div>
  </>;
};